import { fromJS } from 'immutable';
import { SCROLL_UPDATE } from '../../actions';

const initialState = {
  x: -1,
  y: -1
};

function updateScroll(state, action) {
  let newState = fromJS(state);
  newState = newState.merge(action.data.scroll);
  return newState.toJS();
}

export default function(state, action) {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SCROLL_UPDATE:
      return updateScroll(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scroll/index.js